// Entity-related constants and enums

// Transport Types
export enum TransportType {
  AUTO = 'auto',
  PUBLIC_TRANSPORT = 'public_transport',
  PEDESTRIAN = 'pedestrian',
}

export const TRANSPORT_TYPE_LABELS: Record<TransportType, string> = {
  [TransportType.AUTO]: 'Автомобиль',
  [TransportType.PUBLIC_TRANSPORT]: 'Общественный транспорт',
  [TransportType.PEDESTRIAN]: 'Пешком',
};

// Worker Types
export enum WorkerType {
  REGULAR = 'regular',
  MANAGER = 'manager',
  VISITING = 'visiting',
}

export const WORKER_TYPE_LABELS: Record<WorkerType, string> = {
  [WorkerType.REGULAR]: 'Штатный',
  [WorkerType.MANAGER]: 'Менеджер',
  [WorkerType.VISITING]: 'Выездной',
};

// Merchandiser Types
export enum MerchandiserType {
  VISITING = 'visiting',
  PART_TIME = 'part_time',
}

export const MERCHANDISER_TYPE_LABELS: Record<MerchandiserType, string> = {
  [MerchandiserType.VISITING]: 'Выездной',
  [MerchandiserType.PART_TIME]: 'Частичная занятость',
};

// Plan Status
export enum PlanStatus {
  DRAFT = 'draft',
  IN_PROGRESS = 'in_progress',
  OPTIMIZED = 'optimized',
  APPROVED = 'approved',
  COMPLETED = 'completed',
}

export const PLAN_STATUS_LABELS: Record<PlanStatus, string> = {
  [PlanStatus.DRAFT]: 'Черновик',
  [PlanStatus.IN_PROGRESS]: 'В процессе',
  [PlanStatus.OPTIMIZED]: 'Оптимизирован',
  [PlanStatus.APPROVED]: 'Утвержден',
  [PlanStatus.COMPLETED]: 'Выполнен',
};

// Visit Frequency
export enum VisitFrequency {
  DAILY = 'daily',
  WEEKLY_2 = '2_per_week',
  WEEKLY_3 = '3_per_week',
  WEEKLY_4 = '4_per_week',
  WEEKLY_5 = '5_per_week',
  WEEKLY = 'weekly',
  BIWEEKLY = 'biweekly',
  MONTHLY = 'monthly',
}

export const VISIT_FREQUENCY_LABELS: Record<VisitFrequency, string> = {
  [VisitFrequency.DAILY]: 'Ежедневно',
  [VisitFrequency.WEEKLY_2]: '2 раза в неделю',
  [VisitFrequency.WEEKLY_3]: '3 раза в неделю',
  [VisitFrequency.WEEKLY_4]: '4 раза в неделю',
  [VisitFrequency.WEEKLY_5]: '5 раз в неделю',
  [VisitFrequency.WEEKLY]: 'Еженедельно',
  [VisitFrequency.BIWEEKLY]: 'Раз в 2 недели',
  [VisitFrequency.MONTHLY]: 'Ежемесячно',
};

// Days of Week
export const DAYS_OF_WEEK = {
  1: 'Понедельник',
  2: 'Вторник',
  3: 'Среда',
  4: 'Четверг',
  5: 'Пятница',
  6: 'Суббота',
  7: 'Воскресенье',
} as const;

// Default Working Hours
export const DEFAULT_WORKING_HOURS = {
  start: '09:00',
  end: '18:00',
} as const;

// Default Store Hours
export const DEFAULT_STORE_HOURS = {
  weekday: { start: '09:00', end: '21:00' },
  saturday: { start: '09:00', end: '18:00' },
  sunday: { start: '10:00', end: '16:00' },
} as const;

// Entity Limits
export const ENTITY_LIMITS = {
  MAX_NAME_LENGTH: 255,
  MAX_ADDRESS_LENGTH: 500,
  MAX_DESCRIPTION_LENGTH: 1000,
  MAX_PHONE_LENGTH: 20,
  MAX_EMAIL_LENGTH: 100,
  MIN_PASSWORD_LENGTH: 6,
} as const;

// Optimization Settings
export const OPTIMIZATION_SETTINGS = {
  MAX_WORKERS_PER_PLAN: 50,
  MAX_STORES_PER_WORKER: 30,
  DEFAULT_VISIT_DURATION_MINUTES: 30,
  DEFAULT_TIME_LIMIT_SECONDS: 30,
  DEFAULT_SOLUTION_LIMIT: 100,
} as const;